<app-search-bar
  [isButtonTrigger]="true"
  [minChars]="3"
  [maxLength]="maxLength"
  [maxKeywords]="maxKeywords"
  (keywordChange)="onSearch($event)"
  [keyword]="searchTerm"
></app-search-bar>
